import { __ } from '@wordpress/i18n';

// Define a mapping between service type slugs and labels.
const serviceTypes = new Map();

serviceTypes.set('allTypes', __('All Types', 'hst'));
serviceTypes.set('dental', __('Dental', 'hst'));
serviceTypes.set('durableMedicalEquipment', __('Durable Medical Equipment', 'hst'));
serviceTypes.set('federalAdministration', __('Federal Administration', 'hst'));
serviceTypes.set('healthConsumption', __('Health Consumption', 'hst'));
serviceTypes.set('homeHealth', __('Home Health', 'hst'));
serviceTypes.set('hospitals', __('Hospitals', 'hst'));
serviceTypes.set('netCostOfHealthInsurance', __('Net Cost of Health Insurance', 'hst'));
serviceTypes.set('nonDurableMedicalProducts', __('Non-Durable Medical Products', 'hst'));
serviceTypes.set('nursingCare', __('Nursing Care', 'hst'));
serviceTypes.set('otherHealthAndResidential', __('Other Health and Residential', 'hst'));
serviceTypes.set('otherProfessionalServices', __('Other Professional Services', 'hst'));
serviceTypes.set('personalHealthCare', __('Personal Health Care', 'hst'));
serviceTypes.set('physiciansAndClinics', __('Physicians & Clinics', 'hst'));
serviceTypes.set('prescriptionDrug', __('Retail Prescription Drugs', 'hst'));
serviceTypes.set('stateAndLocalAdministration', __('State and Local Administration', 'hst'));
serviceTypes.set('totalAdministration', __('Total Administration', 'hst'));

export default serviceTypes;
